import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'useable/'

const initialState = {
    items: [],
    tills: [],
    cashCounters: [],
    itemsForSalesCounter: [],
    itemCategories: [],
    suppliers: [],
    departments: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getItemList = createAsyncThunk('ru/gil', async (usage = 'all', thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getItemList', { params: { usage } })
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getItemsListForSalesCounter = createAsyncThunk('ru/gilscfb', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getItemsListForSalesCounter')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getItemCategoryList = createAsyncThunk('ru/gicl', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getItemsCateriesList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getTillList = createAsyncThunk('ru/gtl', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getTillList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getCashCounterList = createAsyncThunk('ru/gccl', async (branchID = 1, thunkAPI) => {
    try {
        const result = await axios.post(global.SET_API_URL + 'cashCounters/select', { branchID })
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSupplierList = createAsyncThunk('ru/gsl', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getSupplierList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getExpensesHeads = createAsyncThunk('ru/gsl', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getTillList')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getDepartments = createAsyncThunk('ru/gd', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getDepartments')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const counterSalesSlice = createSlice({
    name: 'ru',
    initialState,
    reducers: {
        reset: (state) => {
            state.items = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getItemCategoryList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getItemCategoryList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.itemCategories = action.payload
            })
            .addCase(getItemCategoryList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getItemsListForSalesCounter.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getItemsListForSalesCounter.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.itemsForSalesCounter = action.payload
            })
            .addCase(getItemsListForSalesCounter.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getItemList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getItemList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.items = action.payload
            })
            .addCase(getItemList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getTillList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getTillList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.tills = action.payload
            })
            .addCase(getTillList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getCashCounterList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getCashCounterList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.cashCounters = action.payload
            })
            .addCase(getCashCounterList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getDepartments.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDepartments.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.departments = action.payload
            })
            .addCase(getDepartments.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getSupplierList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSupplierList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.suppliers = action.payload
            })
            .addCase(getSupplierList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = counterSalesSlice.actions

export default counterSalesSlice.reducer
